var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 134,
    viewBox: "0 0 162 134",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37305 61.6272V62.9928",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30469 62.3662L4.4205 63.5148",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 65.4247H3.57775",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17773 68.5358L4.29355 67.3872",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37305 68.9098V67.5443",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64862 67.9992L7.73828 67.0889",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.469 65.7231H9.10352",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55878 62.5376L8.64844 63.4479",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6543 2V2.91034",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9238 4.73055H77.8342",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6543 7.46161V6.55127",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9299 4.73055H81.0195",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8555 40.2341V41.5996",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7578 44.3309H24.1233",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8555 47.9715V46.606",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4964 44.3309H29.1309",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.833 89.8656C125.921 89.8656 126.803 90.7481 126.803 91.8361C126.803 92.9246 125.921 93.8066 124.833 93.8066C123.745 93.8066 122.863 92.9246 122.863 91.8361",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.848 71.9884C135.017 71.6235 136.81 70.193 137.225 68.6539C137.602 70.0144 139.179 71.6235 140.603 71.7453C139.001 72.3127 137.468 73.9983 137.225 75.3225C137.06 73.9728 134.941 72.1851 133.848 71.9884Z",
    fill: "#C7C7C7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7793 89.2576C14.3643 89.0752 15.2604 88.3601 15.468 87.5905C15.6561 88.2704 16.4448 89.0752 17.1566 89.1362C16.3556 89.4195 15.5897 90.2626 15.468 90.9247C15.3853 90.2498 14.3257 89.3558 13.7793 89.2576Z",
    fill: "#C7C7C7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6371 25.9402C24.6371 26.7844 23.9531 27.4681 23.1095 27.4681C22.2656 27.4681 21.582 26.7844 21.582 25.9402C21.582 25.0965 22.2656 24.4123 23.1095 24.4123C23.9531 24.4123 24.6371 25.0965 24.6371 25.9402Z",
    fill: "#909090"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.638 30.0431C126.638 31.4535 125.494 32.5968 124.085 32.5968C122.674 32.5968 121.531 31.4535 121.531 30.0431C121.531 28.6327 122.674 27.4893 124.085 27.4893C125.494 27.4893 126.638 28.6327 126.638 30.0431Z",
    fill: "#C7C7C7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.001 23.1241C162.001 24.243 161.095 25.1498 159.976 25.1498C158.858 25.1498 157.951 24.243 157.951 23.1241C157.951 22.0051 158.858 21.0983 159.976 21.0983C161.095 21.0983 162.001 22.0051 162.001 23.1241Z",
    fill: "#C7C7C7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1839 117.735C53.1839 118.441 52.6124 119.012 51.9072 119.012C51.2024 119.012 50.6309 118.441 50.6309 117.735C50.6309 117.03 51.2024 116.458 51.9072 116.458C52.6124 116.458 53.1839 117.03 53.1839 117.735Z",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4242 16.1252C52.4242 16.9693 51.7402 17.6531 50.8967 17.6531C50.0531 17.6531 49.3691 16.9693 49.3691 16.1252C49.3691 15.2814 50.0531 14.5972 50.8967 14.5972C51.7402 14.5972 52.4242 15.2814 52.4242 16.1252Z",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3882 131.876C90.4121 132.247 89.3197 131.757 88.9483 130.781C88.577 129.804 89.067 128.711 90.0435 128.34C91.0192 127.969 92.1116 128.459 92.4829 129.435C92.8547 130.412 92.3643 131.504 91.3882 131.876Z",
    stroke: "#EEEEEE",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8068 95.7646H53.4808C50.8536 95.7646 48.7031 93.6077 48.7031 90.9717V37.743C48.7031 35.1069 50.8536 32.9512 53.4808 32.9512H90.8068C93.4351 32.9512 95.5856 35.1069 95.5856 37.743V90.9717C95.5856 93.6077 93.4351 95.7646 90.8068 95.7646Z",
    fill: "#C7C7C7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6193 98.0407H50.2933C47.6661 98.0407 45.5156 95.8839 45.5156 93.2479V40.0191C45.5156 37.3831 47.6661 35.2273 50.2933 35.2273H87.6193C90.2476 35.2273 92.3981 37.3831 92.3981 40.0191V93.2479C92.3981 95.8839 90.2476 98.0407 87.6193 98.0407Z",
    fill: "#E8EBF2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5208 99.8373H47.1176C44.485 99.8373 42.3301 97.6894 42.3301 95.0643V42.0559C42.3301 39.4308 44.485 37.284 47.1176 37.284H84.5208C87.1545 37.284 89.3095 39.4308 89.3095 42.0559V95.0643C89.3095 97.6894 87.1545 99.8373 84.5208 99.8373Z",
    fill: "#D8DBEA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5208 99.8373H47.1176C44.485 99.8373 42.3301 97.6894 42.3301 95.0643V42.0559C42.3301 39.4308 44.485 37.284 47.1176 37.284H84.5208C87.1545 37.284 89.3095 39.4308 89.3095 42.0559V95.0643C89.3095 97.6894 87.1545 99.8373 84.5208 99.8373Z",
    fill: "#EEEEEE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1299 53.435H51.5031C50.7142 53.435 50.0684 52.8206 50.0684 52.07C50.0684 51.3184 50.7142 50.704 51.5031 50.704H79.1299C79.9189 50.704 80.5647 51.3184 80.5647 52.07C80.5647 52.8206 79.9189 53.435 79.1299 53.435Z",
    fill: "#C7C7C7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1299 61.6272H51.5031C50.7142 61.6272 50.0684 61.0128 50.0684 60.2622C50.0684 59.5106 50.7142 58.8962 51.5031 58.8962H79.1299C79.9189 58.8962 80.5647 59.5106 80.5647 60.2622C80.5647 61.0128 79.9189 61.6272 79.1299 61.6272Z",
    fill: "#C7C7C7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1299 69.8199H51.5031C50.7142 69.8199 50.0684 69.2055 50.0684 68.4549C50.0684 67.7043 50.7142 67.0889 51.5031 67.0889H79.1299C79.9189 67.0889 80.5647 67.7043 80.5647 68.4549C80.5647 69.2055 79.9189 69.8199 79.1299 69.8199Z",
    fill: "#C7C7C7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1299 78.0131H51.5031C50.7142 78.0131 50.0684 77.3987 50.0684 76.6481C50.0684 75.8965 50.7142 75.2821 51.5031 75.2821H79.1299C79.9189 75.2821 80.5647 75.8965 80.5647 76.6481C80.5647 77.3987 79.9189 78.0131 79.1299 78.0131Z",
    fill: "#C7C7C7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9239 86.2069H51.5093C50.7169 86.2069 50.0684 85.5925 50.0684 84.8419C50.0684 84.0903 50.7169 83.4759 51.5093 83.4759H65.9239C66.7162 83.4759 67.3648 84.0903 67.3648 84.8419C67.3648 85.5925 66.7162 86.2069 65.9239 86.2069Z",
    fill: "#C7C7C7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.017 75.6172C89.4927 81.1405 80.9405 81.7636 74.7317 77.4992C73.9382 76.9445 73.1829 76.3214 72.4786 75.6172C72.1161 75.2558 71.7743 74.8829 71.4523 74.4903C70.8083 73.7062 70.2441 72.87 69.782 72.006C68.9676 70.5467 68.4139 68.9983 68.1116 67.3977C67.1362 62.3782 68.5946 56.9753 72.4786 53.0931C76.3719 49.1993 81.7757 47.7505 86.7961 48.7164C88.3958 49.0279 89.9457 49.5815 91.4052 50.3865C92.2705 50.859 93.0953 51.423 93.8806 52.067C94.2722 52.3878 94.6452 52.7306 95.0066 53.0931C95.712 53.7973 96.3445 54.5512 96.8889 55.3457C101.155 61.5524 100.531 70.1043 95.017 75.6172Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.472 74.5305C87.7247 80.2788 78.4109 80.2777 72.6626 74.5305C66.9218 68.7896 66.9218 59.4747 72.6701 53.7275C78.4109 47.9866 87.7248 47.9866 93.4656 53.7275C99.2128 59.4747 99.2128 68.7896 93.472 74.5305ZM96.4215 50.7741C89.0444 43.397 77.09 43.397 69.713 50.7741C62.3369 58.1501 62.3305 70.112 69.7065 77.4891C76.4206 84.201 86.944 84.8063 94.3457 79.2954C95.0686 78.7564 95.7648 78.1521 96.429 77.4891C97.092 76.8249 97.6963 76.1287 98.2342 75.4058C103.745 68.003 103.134 57.4871 96.4215 50.7741Z",
    fill: "#C7C7C7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.454 105.296L125.145 105.606C123.096 107.656 119.741 107.656 117.691 105.606L98.7715 86.6871L106.535 78.9231L125.454 97.8421C127.505 99.8921 127.505 103.246 125.454 105.296Z",
    fill: "url(#paint0_linear_668_19827)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6417 74.8268L104.232 80.4174L100.263 84.3853L94.6738 78.7947C95.4115 78.2447 96.1209 77.6281 96.7997 76.9515C97.4762 76.2749 98.0928 75.5645 98.6417 74.8268Z",
    fill: "#C7C7C7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.17 97.6098L117.455 105.323L116.066 103.933L123.78 96.2199L125.17 97.6098Z",
    fill: "#00FFE0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.963 79.1912L99.037 87.1172L97.8594 85.9397L105.785 78.0138L106.963 79.1912Z",
    fill: "#00CCB3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.6663 51.749L70.229 71.1854C69.497 69.8734 68.9992 68.4813 68.7285 67.0424L85.5231 50.2476C86.9611 50.5287 88.3543 51.0253 89.6663 51.749Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.04 56.3692L75.0261 76.1926C74.2736 75.6972 73.5573 75.1396 72.8894 74.5094C72.5455 74.185 72.2203 73.8524 71.916 73.501L93.1859 53.4341C93.5583 53.7222 93.912 54.029 94.2548 54.3534C94.9227 54.9835 95.5237 55.6582 96.04 56.3692Z",
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_19827",
    x1: 151.734,
    y1: 141.087,
    x2: 90.5094,
    y2: 131.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BFA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSearch);
export default __webpack_public_path__ + "static/media/bankSearch.8d2195371341dfb7ddb352fd0abeb7af.svg";
export { ForwardRef as ReactComponent };